<div
	class="position-absolute progress-bar progress-bar progress-bar-striped progress-bar bg-secondary"
	[ngClass]="(loading$ | async) ? 'progress-bar-animated' : ''"
	role="progressbar"
	style="height: 5px; z-index: 1"
	[ngStyle]="(loading$ | async) ? { animation: '2s ease 0s 99 expand' } : { width: '100%' }"
></div>
